import { getTenantRuntime } from '../../app/bootstrap/tenantRuntime';
import {
  getWorkspaceIdentitySession,
  onWorkspaceIdentityChange,
  signOutWorkspaceIdentity,
} from './centralIdentityAuth';
import {
  clearLocalDevSession,
  onLocalDevSessionChange,
  readLocalDevSession,
} from './localDevSession';

export function usesCentralIdentity(runtime = getTenantRuntime()) {
  return runtime?.tenant?.authProvider === 'google_identity_platform';
}

export async function getAccessSession({ forceRefresh = false } = {}) {
  // A local development session (dev builds only) stands in for Identity Platform.
  const local = readLocalDevSession();
  if (local) return local;
  return getWorkspaceIdentitySession({ forceRefresh });
}

export function subscribeAuthState(callback) {
  const unsubscribeIdentity = onWorkspaceIdentityChange((session) => {
    if (readLocalDevSession()) return;
    callback(session ? 'SIGNED_IN' : 'SIGNED_OUT', session);
  });
  const unsubscribeLocal = onLocalDevSessionChange((session) => {
    callback(session ? 'SIGNED_IN' : 'SIGNED_OUT', session);
  });
  const unsubscribe = () => {
    unsubscribeIdentity();
    unsubscribeLocal();
  };
  return { data: { subscription: { unsubscribe } } };
}

export async function signOutAccessSession() {
  if (readLocalDevSession()) {
    clearLocalDevSession();
    return;
  }
  await signOutWorkspaceIdentity();
}
